import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateGoogleWalletProvisionRequest,
  TCreateGoogleWalletProvisionResponse,
} from "./createGoogleWalletProvision.schema";

export const createGoogleWalletProvision = (axios: IAxiosInstance) => {
  return async (
    params: TCreateGoogleWalletProvisionRequest
  ): Promise<IApiResponse<TCreateGoogleWalletProvisionResponse>> => {
    const { paycard_id, ...body } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TCreateGoogleWalletProvisionResponse>
    >(`/api/pay-cards/${paycard_id}/google-wallet-provision`, body);
    return response.data;
  };
};
